import { createApp } from 'vue'
import IfPage from './utils'

// Mounts a Vue 3 app on a Turbo-rendered page and unmounts it before the next
// render. This replaces the Vue 2 vue-turbolinks adapter: without the unmount,
// navigating away and back would stack duplicate apps and leak listeners.
// `setup(app)` runs before mount for registering directives etc.
export default function mountVueOnPage(controller, action, options, setup) {
  let app = null

  const unmount = () => {
    if (app) {
      app.unmount()
      app = null
    }
  }

  document.addEventListener('turbo:load', () => {
    IfPage(controller, action, (page) => {
      unmount()
      app = createApp(options)
      if (setup) setup(app)
      app.mount(page)
    })
  })

  document.addEventListener('turbo:before-render', unmount)
}
